import { create } from 'zustand';

import { TipoProductos } from '@/shared/interfaces';
import { GetTipoProductosParams, getTipoProductos } from '@/shared/actions/erp';

interface TipoProductoStore {
  tipoProductos: TipoProductos[];

  isLoadingTipoProducto: boolean;

  getTipoProducto: (params?: GetTipoProductosParams) => Promise<void>;
}

export const useTipoProductoStore = create<TipoProductoStore>(set => ({
  tipoProductos: [],

  isLoadingTipoProducto: false,

  getTipoProducto: async params => {
    set({ isLoadingTipoProducto: true });

    const { data } = await getTipoProductos(params);
    set({ tipoProductos: data.data });

    set({ isLoadingTipoProducto: false });
  },
}));
